import type { ReactNode } from "react";

type Tone = "surface" | "slate" | "amber";

const toneCls: Record<Tone, string> = {
  surface: "bg-white",
  slate: "bg-[#f8fafc]",
  amber: "bg-amber-50",
};

export function Section({
  children,
  tone = "surface",
  className,
  id,
}: {
  children: ReactNode;
  tone?: Tone;
  className?: string;
  id?: string;
}) {
  return (
    <section id={id} className={[toneCls[tone], "py-16 sm:py-24", className ?? ""].join(" ")}>
      <div className="mx-auto max-w-6xl px-4">{children}</div>
    </section>
  );
}
